import { Selection, select } from "d3";
import "../../../styles/pages/Event-humor.scss";
import { _APP_DATA } from "../../data/AppData";
import { EEventId, EHumorID, IConfiguration } from "../../data/models/Entities";
import { _ESCOLARIDAD_CONFIGURACION_MAP, _SvEscolaridadObtenerConfiguracion } from "../../data/services/Escolaridad";
import { _EVENTO_COMENTARIOS_MAP, _EVENTO_HUMOR_VALUES_MAP } from "../../data/services/Evento";
import _L from "../../utils/Labels";
import { BaseUIEvent } from "../bases/BaseUIEvent";
import { Input } from "../components/Input";
import { LOADING } from "../components/Loading";
import { ShowToast } from "../components/Toast";
import { _CreateElementFromHTML } from "../utils/General";
import ic_done_selected from "/icons/ic_done_selected.svg?raw";

export class EventHumor extends BaseUIEvent {

    private txtComment?: Input;
    private humorSelected: { idEvent: EHumorID, label: string, iconSVGRaw: string };

    constructor() {
        super('ui-event-humor', EEventId.HUMOR);
    }

    protected InitClass(): void {
        LOADING.Show();
        this.CreateLisHumor();
        this.AddSaveBtn();
        this.LoadData();
    }

    private LoadData() {
        _SvEscolaridadObtenerConfiguracion(_APP_DATA.userData.IdNivel, (_: number, __: Array<IConfiguration>) => {
            let datum = Array.from(_ESCOLARIDAD_CONFIGURACION_MAP.values()).filter(o => o.Tipo == EEventId.HUMOR);
            let estados = datum[0].Valores;
            let moods = Array.from(_EVENTO_HUMOR_VALUES_MAP.values());

            for (let i = 0; i < estados.length; i++) {
                let estado =
                    estados[i];
                moods[i].label = estado;
            }

            this.CreateLisHumor();


            LOADING.Dismiss();
        });
    }

    private CreateLisHumor() {
        this.bodyContainer.selectAll("*").remove();
        const divIcons = this.bodyContainer.append("div").classed("div-icons", true);

        const listHumor = Array.from(_EVENTO_HUMOR_VALUES_MAP.values());
        let row: Selection<HTMLDivElement, any, any, any>;
        const self = this;
        listHumor.forEach((item, i) => {
            if (i % 4 == 0) {
                row = divIcons.append("div").classed("row-humor-icon", true);
            }

            const itemIc = row.append("div")
                .classed("item-icon", true)
                .datum(item).call((btn) => {
                    btn.insert("div").classed("active-indicator", true).html(ic_done_selected)
                });
            itemIc.append(() => _CreateElementFromHTML(item.iconSVGRaw));
            itemIc.append("h3").classed("txt-label", true).text(item.label)
            itemIc.on("click", function (_, d) {
                divIcons.selectAll(".item-icon.active").classed("active", false);

                select(this).classed("active", true);
                self.humorSelected = d;
            });
        });

        let listComments = _EVENTO_COMENTARIOS_MAP.get(EEventId.HUMOR) || [];
        this.txtComment = new Input(this.bodyContainer, { inputType: 'textarea', concatValueSelected: true })
            .SetPlaceholder(_L("general.comentario"))
            .SetDefaultOptions(listComments.map(o => o.Mensaje));
    }

    protected OnSaveClick(): void {
        if (!this.humorSelected) {
            ShowToast(_L("humor.title"), _L("humor.humor_required"), 'info')
            return;
        }
        if (!this.txtComment.Validate()) return;

        const comment = this.txtComment?.value.trim() || "";


        this.AddCommonGralEvent({
            titleToast: _L("humor.title"),
            evtID: EEventId.HUMOR,
            comment: comment,
            category: 0,
            identifier: this.humorSelected.idEvent
        });
    }
}